import { RenameModal } from "./RenameModal/RenameModal.tsx";
import { DeleteModal } from "./DeleteModal/DeleteModal.tsx";
import { MoveModal } from "./MoveModal/MoveModal.tsx";
import { DuplicateModal } from "./DuplicateModal/DuplicateModal.tsx";
import { CreateFolderModal } from "./CreateFolderModal/CreateFolderModal.tsx";
import { TagsModal } from "./TagsModal/TagsModal.tsx";
import { ApprovalModal } from "./ApprovalModal/ApprovalModal.tsx";
import { DetailsModal } from "./DetailsModal/DetailsModal.tsx";
import { UploadModal } from "./UploadModal/UploadModal.tsx";
import { ShareModal } from "./ShareModal/ShareModal.tsx";

export function FileManagerModals() {
  return (
    <>
      <RenameModal />
      <DeleteModal />
      <MoveModal />
      <DuplicateModal />
      <CreateFolderModal />
      <TagsModal />
      <ApprovalModal />
      <DetailsModal />
      <UploadModal />
      <ShareModal />
    </>
  );
}
